export const tabs = ["Cricket", "Baseball", "Football", "Basketball", "Tennis"];
